import React from 'react';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import { AnalyticsTrackAction, AnalyticsTrackSubject, sendAnalyticsEvent } from '@atlassian/temp-analytics';
import { ShipToPartySidebar } from '@css-xp/ppc-ship-to-party-sidebar';

interface Props {
  isOpen: boolean;
  transactionAccountId: string;
  onClose: () => void;
  onSuccess: React.ComponentProps<typeof ShipToPartySidebar>['onSubmitComplete'];
}

export const AddCustomerModal = ({ isOpen, transactionAccountId, onClose, onSuccess }: Props) => {
  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} testId="add-customer-modal" shouldCloseOnOverlayClick={false} shouldScrollInViewport>
          <div className="pa-16">
            <ShipToPartySidebar
              onCancelClick={onClose}
              onSubmitComplete={onSuccess}
              onSubmitFailure={() =>
                sendAnalyticsEvent(AnalyticsTrackAction.FAILED, AnalyticsTrackSubject.NEW_CUSTOMER, {
                  transactionAccountId,
                })
              }
              beforeSubmit={() =>
                sendAnalyticsEvent(AnalyticsTrackAction.ADDED, AnalyticsTrackSubject.NEW_CUSTOMER, {
                  transactionAccountId,
                })
              }
              transactionAccountId={transactionAccountId}
              hideAddFromBillToAddress={true}
              contentString={{
                HEADING: 'Add customer',
                SUBMIT_BUTTON: 'Add customer',
                NOTIFICATION_SUCCESS_HEADING: 'Customer added',
              }}
            />
          </div>
        </Modal>
      )}
    </ModalTransition>
  );
};
